import Head from "next/head";
import Link from "next/link";
import Image from "next/image";
import { Button, Container } from "react-bootstrap";

import withAuth from "src/components/withAuth";
import appEmbedExample from "public/assets/app-embed-example.png";
import styles from "src/components/shopify/shopify.module.scss";
import { useShopifyAppBridge } from "src/components/shopify/appBridge";

function ShopifyWelcomePage() {
    const { getShop } = useShopifyAppBridge();
    const shop = getShop();

    return (
        <>
            <Head>
                <title>Welcome - Tote Dashboard</title>
            </Head>

            <Container className={styles.welcomeContainer}>
                <h1>Welcome to TOTE! Here's how it works.</h1>

                <div id="widget">
                    <div className={styles.exampleContainer}>
                        <iframe
                            className={styles.introductionVideo}
                            width="315"
                            height="300"
                            src="https://www.youtube.com/embed/dVkYRH47zMg"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                        <div className={styles.exampleImage}>
                            <Image
                                src={appEmbedExample}
                                alt="An example configuration of the Tote app embed block within the Shopify theme editor"
                            />
                        </div>
                    </div>

                    <div>
                        <strong>Step 1:</strong> Add our widget to your store
                        theme. To install the widget, click the preview button
                        below, or follow these steps:
                        <ol>
                            <li>
                                Open the{" "}
                                <a
                                    target="_blank"
                                    href={`https://${shop}/admin/themes/current/editor`}
                                >
                                    theme editor
                                </a>{" "}
                                to customize your store's theme.
                            </li>
                            <li>
                                Click on <strong>"Theme Settings"</strong> at
                                the bottom of the left-hand sidebar.
                            </li>
                            <li>
                                In the right-hand sidebar, click on the{" "}
                                <strong>"App embeds"</strong> tab.
                            </li>
                            <li>
                                Enable the TOTE Shop Widget by toggling its
                                switch on.
                            </li>
                            <li>
                                Click on the caret next to "Shop Widget" to view
                                customization options, as seen to the right. You
                                can change the label on the button, the position
                                of the button, and the colors it uses.
                            </li>
                            <li>
                                Save your changes, and you should see the widget
                                live on your storefront!
                            </li>
                        </ol>
                        <Button
                            className={styles.themeDeeplinkBtn}
                            target="_blank"
                            href={`https://${shop}/admin/themes/current/editor?context=apps&activateAppId=${CONFIG.shopify.themeAppExtensionUuid}/app-embed`}
                        >
                            Preview in theme
                        </Button>
                    </div>
                </div>

                <p>
                    <strong>Step 2:</strong> Click{" "}
                    <Link href="/schedule">
                        <a>“Schedule”</a>
                    </Link>{" "}
                    on the sidebar to the left. Check the “Availability” box on
                    days you are open for appointments and set your hours
                    accordingly. You can also set appointment duration and
                    minimum amount of time a shopper can book an appointment in
                    advance. Remember to click “Save”.
                </p>

                <p>
                    <strong>Step 3:</strong> Click{" "}
                    <Link href="/questionnaire">
                        <a>“Questionnaire”</a>
                    </Link>{" "}
                    on the sidebar. This is where you can add personalization
                    questions for your customers. Click “Add New Question”, type
                    in your question, and choose “free text” or “multiple
                    choice”. Enter your answers if multiple choice. Remember to
                    click “Save”. Questions can be edited anytime and instantly
                    update in your TOTE Button.
                </p>

                <p>
                    <strong>Step 4:</strong> Click on{" "}
                    <Link href="/settings">
                        <a>“Settings”</a>
                    </Link>
                    . Here you can fill out your Store Name, Website, Email
                    Addresses, Store Address (if you have one), and Timezone for
                    virtual appointments. Remember to click “Save”.
                </p>

                {/* <h1>
                    Additional Steps For Fitting Room Tier Customers ($59/month)
                </h1>

                <div>
                    <strong>Step 5:</strong> Add our custom Fitting Room Button
                    Element to your store's theme's Product Page specifically.
                    To add the custom Element, follow these steps:
                    <ol>
                        <li>
                            Open the{" "}
                            <a
                                target="_blank"
                                href={`https://${shop}/admin/themes/current/editor`}
                            >
                                theme editor
                            </a>{" "}
                            to customize your store's theme.
                        </li>
                        <li>
                            Use the page selector dropdown at the top of the
                            screen to navigate to the Default Product Page. The
                            Fitting Room Widget functionality only makes
                            contextual sense on a per-product page.
                        </li>
                        <li>
                            On the left hand side, in the Product Information
                            settings, do "+ Add Block". A new type of block
                            should be available to add&mdash;the "Tote Fitting
                            Room" button.
                        </li>
                        <li>
                            Drag it to be nearer the Buy Buttons, where it makes
                            the most contextual sense.
                        </li>
                    </ol>
                </div>

                <p>
                    Don't hesitate to reach out to us with any questions at all!
                </p>

                <p>- The TOTE Team</p>

                <Link href="/">
                    <Button variant="primary" className={styles.finishBtn}>
                        Get started
                    </Button>
                </Link> */}
            </Container>
        </>
    );
}

export default withAuth(ShopifyWelcomePage);
